import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing4,
  spacing8,
  spacing16,
  spacing40,
} from 'approot/shared/styles/spacing.style';
import {
  grey1,
  grey4,
  grey10,
  purple7,
} from 'approot/shared/styles/colours.style';
import {
  baseBoxShadowFocus,
  borderRadius8,
} from 'approot/shared/styles/borders.style';
import { SecondaryBaseStyled } from 'approot/shared/styles/buttons/secondary-button.style';

export const RangeContainer = styled.div`
  text-align: center;
`;

export const RangeButton = styled.button`
  ${SecondaryBaseStyled}
  border-radius: ${rem(24)};
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${rem(24)};
  height: ${rem(24)};
  width: ${rem(24)};
  padding: 0;
  top: ${rem(spacing4)};
  z-index: 1;

  &:hover {
    cursor: pointer;
  }
`;

export const RangeContent = styled.div`
  height: ${rem(16)};
  left: ${rem(spacing40)};
  right: ${rem(spacing40)};
  position: absolute;
  top: ${rem(spacing8)};
`;

export const RangeTrack = styled.div`
  background-color: ${grey4};
  border-radius: ${rem(borderRadius8)};
  height: ${rem(8)};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: ${rem(spacing8)};
  right: ${rem(spacing8)};
`;

export const RangeTrackFiller = styled.div`
  padding-left: ${rem(spacing8)};
  padding-right: ${rem(spacing8)};
  position: relative;
  top: 50%;
`;

export const RangeTrackFillerWrapper = styled.div`
  background-color: ${purple7};
  border-radius: ${rem(borderRadius8)};
  height: ${rem(8)};
  position: relative;
  transform: translateY(-50%);
  width: 100%;
`;

export const RangeTrackKnob = styled.div`
  background-color: ${grey1};
  border-radius: 50%;
  border: 3px solid ${purple7};
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);
  height: ${rem(16)};
  left: 100%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: ${rem(16)};
`;

export const RangeSlider = styled.div`
  height: ${rem(32)};
  margin: auto;
  margin-bottom: ${rem(spacing16)};
  max-width: ${rem(300)};
  position: relative;
  width: 100%;

  button {
    position: absolute;
  }

  button:first-child {
    left: 0;
  }

  button:last-child {
    right: 0;
  }
`;

export const RangeContentSlider = styled.div`
  height: ${rem(16)};
`;

export const RangeField = styled.input`
  position: absolute;
  left: ${rem(spacing40)};
  right: ${rem(spacing40)};
  margin: 0;
  opacity: 0;
  top: ${rem(spacing8)};
  z-index: 1;

  &:hover {
    cursor: pointer;
  }

  &:focus
    + ${RangeContent}
    ${RangeTrackKnob},
    &:focus
    + ${RangeContentSlider}
    ${RangeTrackKnob} {
    box-shadow: ${baseBoxShadowFocus};
    border: 1px solid ${grey10};
  }

  &:disabled {
    & + ${RangeContent} {
      opacity: 0.4;
    }
    &:hover {
      cursor: not-allowed;
    }
  }
`;

export const RangeContentSliderWrapper = styled.div`
  position: relative;
  padding: 0 ${rem(spacing8)};
  width: 100%;

  ${RangeTrack} {
    left: ${rem(spacing16)};
    right: ${rem(spacing16)};
  }
  ${RangeField} {
    left: ${rem(spacing8)};
    right: ${rem(spacing8)};
    top: 0;
  }
`;
